import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';

interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
}

const Drawer: React.FC<DrawerProps> = ({ isOpen, onClose, children, title }) => {
  const drawerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const html = document.querySelector('html');
    if (html) {
      html.style.overflowY = isOpen ? 'hidden' : 'visible';
    }
    return () => {
      if (html) {
        html.style.overflowY = 'visible';
      }
    };
  }, [isOpen]);

  if (!isOpen || typeof document === 'undefined') {
    return null;
  }

  return ReactDOM.createPortal(
    <div className="fixed inset-0 z-50 overflow-hidden">
      <div className="absolute inset-0 overflow-hidden">
        <div
          className="absolute inset-0 bg-black/60 backdrop-blur-sm transition-opacity"
          onClick={onClose}
        />

        <div className="fixed inset-y-0 right-0 flex max-w-full pl-10">
          <div
            ref={drawerRef}
            className="w-screen max-w-md transform transition-transform duration-500 ease-in-out"
          >
            <div className="flex h-full flex-col overflow-y-auto bg-panel border-l border-line shadow-2xl">
              <div className="px-6 py-4 border-b border-line flex items-center justify-between">
                <h2 className="font-['Archivo'] text-[15px] font-bold text-text">
                  {title}
                </h2>
                <button
                  onClick={onClose}
                  className="w-8 h-8 flex items-center justify-center text-muted hover:text-text transition-colors cursor-pointer"
                >
                  <X className="h-6 w-6" />
                </button>
              </div>

              <div className="relative flex-1 px-6 py-5 overflow-y-auto">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Drawer;
